const base = process.env.REACT_APP_BASEURL;
const dashboardUrl = "/cms";
const authUrl = "/auth";
let mailService = process.env.REACT_APP_API_URL + "/api/email";
let mailchimpService = process.env.REACT_APP_API_URL + "/api/mailchimp";
let exactService = process.env.REACT_APP_API_URL + "/api/exact";

module.exports = {
  base: base,
  dashboard: dashboardUrl,
  auth: authUrl,
  login: authUrl + "/login",
  forgotPassword: authUrl + "/forgot-password",
  acceptInvite: authUrl + "/invite/",
  products: dashboardUrl + "/products",
  categories: dashboardUrl + "/categories",
  productList: dashboardUrl + "/products/product-list",
  addProduct: dashboardUrl + "/products/add-product",
  editProduct: dashboardUrl + "/products/edit-product/",
  productAttributes: dashboardUrl + "/products/attributes",
  productEvents: dashboardUrl + "/products/product-events",
  discounts: dashboardUrl + "/discounts/",
  promotions: dashboardUrl + "/discounts/promotions",
  discountCodes: dashboardUrl + "/discounts/discount-codes",
  ordersList: dashboardUrl + "/orders/all",
  exactOrdersList: dashboardUrl + "/orders/exact",
  purchaseOrdersList: dashboardUrl + "/purchase-orders/all",
  productDraftsList: dashboardUrl + "/purchase-orders/product-drafts",
  suppliersList: dashboardUrl + "/purchase-orders/suppliers",
  purchaseOrderShipmentsList: dashboardUrl + "/purchase-orders/shipments",
  purchaseOrderShipmentDetail: dashboardUrl + "/purchase-orders/shipments/",
  purchaseOrderInvoicesList: dashboardUrl + "/purchase-orders/invoices",
  purchaseOrderInvoiceDetail: dashboardUrl + "/purchase-orders/invoices/",
  stockOverview: dashboardUrl + "/purchase-orders/stock",
  shipmentsList: dashboardUrl + "/shipments",
  shipmentDetail: dashboardUrl + "/shipments/",
  customerList: dashboardUrl + "/customers/all",
  customerListPending: dashboardUrl + "/customers/pending",
  customerMap: dashboardUrl + "/customers/map",
  audiences: dashboardUrl + "/customers/audiences",
  audienceDetail: dashboardUrl + "/customers/audiences/",
  users: dashboardUrl + "/admin/users",
  groups: dashboardUrl + "/admin/groups",
  collections: dashboardUrl + "/admin/collections",
  welcome_email: mailService + "/signup/welcome",
  resend_confirmation_email: mailService + "/order/confirmed/resend",
  exactAccount: exactService + "/client",
  exactOrder: exactService + "/sales_order",
  reports: dashboardUrl + "/reports",
  reportsGeneral: dashboardUrl + "/reports/general",
  reportsProducts: dashboardUrl + "/reports/products",
  reportsSellers: dashboardUrl + "/reports/sellers",
  sendInvite: mailService + "/invite/cms",
  addUsersMailchimp: mailchimpService + "/add_users",
  getExactOrders: exactService + "/orders",
  getExactItem: exactService + "/item/",
  getExactSuppliers: exactService + "/suppliers",
  getExactSupplierItems: exactService + "/suppliers/",
  dealers: dashboardUrl + "/dealers",
  purchaseOrderDetail: dashboardUrl + "/orders/purchase-orders/",
  documentation: dashboardUrl + "/documentation",
};
